const CustomSection = ({
  id,
  children,
  className,
  center,
  bg_color = "var(--background-color0)",
  bg_image = false,
  style = {},
  style_child = false,
  remove_border = false,
}) => {
  return (
    <section
      id={id}
      className={className ?? ""}
      style={{
        display: "grid",
        minHeight: "100vh",
        backgroundColor: bg_color,
        transition: "all 0.3s ease",
        ...style,
        ...(remove_border
          ? ""
          : { borderBottom: "0.16rem solid rgba(105, 59, 159, 0.1)" }),
        ...(center ? { justifyContent: "center", alignItems: "center" } : ""),
        ...(bg_image
          ? {
              background: `url(${bg_image}) no-repeat`,
              backgroundPosition: "center bottom",
              backgroundSize: `cover`,
            }
          : ""),
      }}
    >
      <div
        style={{
          display: "flex",
          height: "100%",
          width: "100%",
          ...(style_child ? style : {}),
        }}
      >
        {children}
      </div>
    </section>
  );
};

export default CustomSection;
